import { render, staticRenderFns } from "./bo-text-block.vue?vue&type=template&id=d255d718"
import script from "./bo-text-block.vue?vue&type=script&lang=js"
export * from "./bo-text-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports